/*
 * Rating — 별점(1~5). Tag/InlineEditField와 마찬가지로 contract가 없는 신규 컴포넌트라
 * Drawer.tsx 선례를 따라 손으로 작성했다(Tailwind 유틸 + 토큰 클래스, 생성 컴포넌트 패턴 아님).
 * value=0(미평가)이면 별 5개 모두 빈 상태로 보여준다. readOnly=true면 클릭 불가(표시 전용).
 */
import { cx } from '../cx';

export interface RatingProps {
  value: number;
  onChange?: (value: number) => void;
  readOnly?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_PX: Record<NonNullable<RatingProps['size']>, number> = { sm: 14, md: 18, lg: 22 };

export function Rating({ value, onChange, readOnly = false, size = 'md', className = '' }: RatingProps) {
  const px = SIZE_PX[size];
  return (
    <div
      className={cx('inline-flex items-center gap-0.5', className)}
      role={readOnly ? undefined : 'radiogroup'}
      aria-label="평점"
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const filled = star <= value;
        return (
          <button
            key={star}
            type="button"
            disabled={readOnly}
            aria-label={`${star}점`}
            aria-checked={readOnly ? undefined : value === star}
            role={readOnly ? undefined : 'radio'}
            onClick={() => onChange?.(star)}
            className={cx(
              'leading-none transition-colors',
              readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110',
              filled ? 'text-warning' : 'text-border',
            )}
            style={{ width: px, height: px }}
          >
            <svg viewBox="0 0 24 24" width={px} height={px} fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3.5l2.6 5.4 5.9.8-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.2 5.9-.8z"
              />
            </svg>
          </button>
        );
      })}
    </div>
  );
}
